export const mandatoryBlocksIdsForTP = [1, 2, 8, 12, 15, 19, 30, 33, 35, 42, 46, 47];
export const mandatoryBlocksIdsForOD = [2, 8, 10, 12, 15, 20, 26, 27, 42, 43, 46, 47];
export const mandatoryBlocksIdsForHealth = [22, 25, 34];


